import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReplace = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 8.55 8.91",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "square",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M5.61 3.36h2.33V.56" }),
			/* @__PURE__ */ _jsx("path", { d: "M7.66 2.87a3.72 3.72 0 0 0-7.05.49" }),
			/* @__PURE__ */ _jsx("path", { d: "M2.94 5.56H.6v2.79" }),
			/* @__PURE__ */ _jsx("path", { d: "M.89 6.05a3.72 3.72 0 0 0 7.05-.49" })
		]
	})
});
export { SvgReplace as ReactComponent };
